import { Popover as MantinePopover, PopoverProps } from '@mantine/core';

export type IPopoverProps = PopoverProps;

/** @registry Design-layer pass-through over Mantine Popover; import this instead of @mantine/core Popover outside src/design. Extend here when Popover needs house behavior. Compound statics (Popover.Target, Popover.Dropdown) are preserved. */
export const Popover = MantinePopover;
